export const V2_CONNECTIONS_MESSAGE_TEXT = {
    id: 'oe.uploadMeeting.v2connectionMessageText',
    description: 'Info Message',
    defaultMessage: `If V2 Connections are enabled, then any new meetings created by the upload will be V2 version, meaning they support Connection Groups.
      Any meetings edited by the upload will remain V1 or V2 according to how they were created.`
};

export const CONNECTION_VERSION_TEXT = {
    message: 'V2 connections are {suffix}',
    id: 'oe.uploadMeeting.connectionVersion',
    description: 'Label text',
};